import React from 'react';
import { StandardProps } from '@/newcar/ui/contract';
import * as styles from './index.module.styl';

interface CheckProps extends StandardProps {
  /**
   * @required
   * @type {string}
   * @memberof CheckProps
   */
  id: string;

  /**
   * @required
   * @type {string}
   * @memberof CheckProps
   */
  label: string;

  /**
   * @required
   * @type {string | number}
   * @memberof CheckProps
   */
  value: string | number;

  /**
   * @required
   * @type {boolean}
   * @memberof CheckProps
   */
  checked?: boolean;

  /**
   * @required
   * @type {(event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>}
   * @memberof CheckProps
   */
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
}

// 単一のチェック用コンポーネント
export default function Check(props: CheckProps): JSX.Element {
  const {
    id,
    label,
    value,
    checked = false,
    className = '',
    onChange,
  } = props;

  return (
    <div className={styles.cCheck}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className={`${styles.cCheckRequired} is-size-4 ${className}`}>
        <input
          id={id}
          name="check"
          type="checkbox"
          checked={checked}
          value={value}
          onChange={onChange}
        />
        <span className={`${checked ? styles.checked : ''}`}>
          <i className={`${styles.cCheckCheck}`} />
          {label}
        </span>
      </label>
    </div>
  );
}
